// Feature flags — hide in-progress features from the UI without removing code.
//
// Pattern:
//   - Code (pages, modals, hooks) stays in the repo.
//   - This file controls whether the feature is wired into routes + sidebar.
//   - Flip a flag to `true` when the feature is ready to ship.
//   - On a final pre-release pass, flip the whole batch to unlock everything.
//
// To gate a sidebar section: add `flag: '<name>'` to the SECTIONS entry in
// `frontend/src/lib/sections.js`. The section disappears until the flag is on.
//
// To gate a route: wrap the <Route> in `{FEATURES.<name> && <Route ... />}` in
// `frontend/src/App.js`. Direct visits to the URL fall through to the catch-all
// redirect to "/".

export const FEATURES = {
  documents: false,  // F-007 Document Hub — design WIP, ship later as an update
};
